export default __webpack_public_path__ + "static/Hydzik-aa637ab4750b3ad4013e4cb7b80f8cf8.jpg";